import { firestore } from '../plugins/firebase'

const db = firestore.collection('sections')

const sectionsService = {
  list: async (currentUserId) => {
    const response = await db
      .where('owner', '==', currentUserId)
      .get()

    return response
  },

  create: async (content) => {
    const response = await db.add(content)

    if (response) {
      let newObj = {}
      newObj.id = response.id
      newObj.data = content
      return newObj
    }

    return false
  },

  get: async (docId) => {
    const response = await db.get()
    return response
  },

  update: async (doc) => {
    const response = db.doc(doc.id).set(doc.data)
    return response
  },

  delete: async (docId) => {
    const response = db
      .doc(docId)
      .delete()
    return response
  }
}

export default sectionsService
